import React from 'react';

import styled from '@mint-lib/styled';

import { Box, Typography } from '@myn/mui';

type ffObject = {
  [key: string]: {
    enabled: boolean;
  };
};

type Props = {
  title: string;
  description?: string;
  children: React.ReactNode;
  ff?: ffObject;
};

const BlockBox: React.FC<Props> = ({ title, description, children, ff }) => (
  <Container p={2}>
    <Title>
      <Typography variant="h6">{title}</Typography>
      {!!description && (
        <Typography variant="bodyShort01" mt={0.5}>
          {description}
        </Typography>
      )}
    </Title>
    {children}
  </Container>
);

const Container = styled(Box)`
  font-size: 1rem;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.palette.ui.primary};
  box-shadow:
    0 1px 2px 0 rgba(0, 0, 0, 0.15),
    0 0 5px 0 rgba(23, 24, 24, 0.05);
`;

const Title = styled('div')`
  margin-bottom: ${({ theme }) => theme.spacing(1)};

  > span {
    display: block;
    color: ${({ theme }) => theme.palette.text.secondary};
  }
`;

export default BlockBox;
